import React from 'react';
import './Switch.css';

const Switch = ({ isOn, handleToggle, onColor, myKey, title, small= false }) => {
  return (
    <div style={{display: 'flex', flex: 1}} key={myKey}>
      <div style={{height: small ? 'min-content' : '50px'}}>
        <input
          checked={isOn}
          onChange={handleToggle}
          className="react-switch-checkbox-big"
          id={`react-switch-new-${myKey || Math.random()}`}
          type="checkbox"
        />
        <label
          style={{ background: isOn && onColor }}
          className="react-switch-label-big"
          htmlFor={`react-switch-new-${myKey || Math.random()}`}
        >
          <span className={`react-switch-button-big`} />
        </label>
      </div>
      
      <div className="ml-2">
         <p className={`insideFont  ${small ? 'mb-0' : ''}`}>{title}</p>
      </div>
     
    </div>
  );
};

export default Switch;